import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { MEDIA_QUERIES, SPACER } from 'radiance-ui/lib/constants';

import { LOCAL_CONTENT_MAX_WIDTH } from 'styles/constants';
import { mobileOnly, desktopOnly } from 'styles/mixins/displayMobileDesktop';
import getContrastingColor from 'utils/getContrastingColor';

export const FaqContainer = styled.div<{ backgroundColor: string }>`
  --text-color: ${({ backgroundColor }) =>
    backgroundColor && getContrastingColor(backgroundColor)};
  background: ${({ backgroundColor }) => backgroundColor};
  margin: 0;
  padding: 0;

  h2,
  p,
  small {
    color: var(--text-color);
  }
`;

export const FaqInnerBox = styled.div<{
  hideMobileCtaButton?: boolean;
  themeType: string;
}>`
  margin: 0 auto;
  max-width: ${LOCAL_CONTENT_MAX_WIDTH};
  position: relative;
  padding: ${SPACER.base};

  ${MEDIA_QUERIES.mdUp} {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: flex-start;
    padding: ${SPACER.x4large} 72px ${SPACER.x2large};

    ${({ themeType }) =>
      themeType === 'secondary'
        ? `
          flex-direction: column;
          gap: 3.75rem;
        `
        : ''};
  }

  ${MEDIA_QUERIES.xxlUp} {
    padding: ${SPACER.x4large} 0 ${SPACER.x2large};
  
`;

export const FaqCopyAndCtaContainer = styled.div<{ themeType: string }>`
  ${({ themeType }) =>
    themeType === 'primary'
      ? 'max-width: 23rem;'
      : `
        display: flex;
        justify-content: space-between;
        width: 100%;
      `};
`;

export const FaqTitle = styled.h2`
  color: var(--text-color);
  font-size: 2rem;
  font-weight: 700;
  line-height: 110%;
  letter-spacing: -0.04rem;

  ${MEDIA_QUERIES.mdUp} {
    font-size: 3.25rem;
    letter-spacing: unset;
  }
`;

export const bodyStyles = css`
  margin-top: ${SPACER.large};

  ${MEDIA_QUERIES.mdUp} {
    margin-top: ${SPACER.medium};
  }
`;

export const QuestionsBox = styled.div<{ themeType: string }>`
  margin-top: ${SPACER.xlarge};

  ${MEDIA_QUERIES.mdUp} {
    margin-top: 0;
    width: 100%;
  }

  ${MEDIA_QUERIES.xlUp} {
    ${({ themeType }) => (themeType === 'primary' ? 'width: 656px;' : '')};
  }
`;

export const desktopButtonStyles = css`
  ${desktopOnly('grid')};
`;

export const mobileButtonStyles = css`
  ${mobileOnly('grid')};
  margin-top: ${SPACER.large};
`;
